import React from "react";
import "../../Share/Style.css";

const ResumeDetails = ({ item }) => {
  // console.dir(item);
  const Icon = item.icon;
  return (
    <>
      <div className="resume">
        <div className="flex items-center space-x-2 mb-4">
          <Icon className="text-6xl text-[#F95054]" />
          <h4 className="text-5xl dark:text-white font-medium">{item?.type}</h4>
        </div>
        {item?.dataUpdationDate ? (
          <div className="pb-5">
            <h5 className="text-sm dark:text-white font-small">
              <b>Last updated on:</b>{" "}
              <i>{item?.dataUpdationDate}</i>
            </h5>
          </div>
        ) : (
          <></>
        )}
        {item?.data?.map((eachItem) => (
          <div key={eachItem.id} className="resume-item">
            <h4 className="text-[#050d18] dark:text-[#ff9900] mt-1">
              {eachItem.title}
            </h4>
            {eachItem?.logoUrl ? <img className="max-h-[12rem] max-w-[12rem] p-2" src={eachItem?.logoUrl} alt={eachItem?.title} /> : <></>}
            <h5 className="bg-[#e4edf9] dark:bg-[#4c5c70] dark:text-white">
              {eachItem.date}
            </h5>
            <p className="dark:text-[#d4c9c9]">
              <em>{eachItem.place}</em>
            </p>
            <p className="resume-item-details dark:text-white">
              {eachItem?.details}
            </p>
          </div>
        ))}
      </div>
    </>
  );
};

export default ResumeDetails;
